module.exports = __webpack_public_path__ + "static/media/grid-item-b16.fa86d456.png";